import {
  COOKIE_CHANNEL_NAME,
  COOKIE_CHANNEL_NAME_TEMPORARY,
  DEFAULT_CHANNEL,
  fixedChannelHosts
} from "@website/utils/channel/constants";
import { getChannel } from "@website/utils/channel/get-channel";
import { setCookie } from "@website/utils/cookie";
import { isSSR } from "@website/utils/is-ssr";

export const setChannel = () => {
  if (isSSR()) return;
  const queryParameters = new URLSearchParams(window.location.search);
  const secure = window.location.protocol === "https:";
  let COOKIE_OPTIONS = {
    path: "/",
    maxAge: 60 * 60 * 24 * 7, // 7 روز
    sameSite: "lax" as const,
    httpOnly: false,
    secure
  };

  const fixedChannel = fixedChannelHosts[window.location.hostname];
  const queryChannel = queryParameters.get(COOKIE_CHANNEL_NAME);
  const temporaryChannel = queryParameters.get(COOKIE_CHANNEL_NAME_TEMPORARY);

  if (!fixedChannel && !queryChannel && temporaryChannel) {
    COOKIE_OPTIONS = {
      path: "/",
      maxAge: 60 * 30, // 30 دقیقه
      sameSite: "lax" as const,
      httpOnly: false,
      secure
    };
  }

  const channel =
    fixedChannel ||
    queryChannel ||
    temporaryChannel ||
    getChannel() ||
    DEFAULT_CHANNEL;

  document.querySelector("html")?.classList.add(channel);
  setCookie(COOKIE_CHANNEL_NAME, channel, COOKIE_OPTIONS);
};
